module.exports = __webpack_public_path__ + "img/p29.1be40557.jpg";